export default __webpack_public_path__ + "static/media/locht-logo.817eb953.svg";